// extracted by mini-css-extract-plugin
export var arrows = "home-module--arrows--a2vBS";
export var card1 = "home-module--card1--0IAyf";
export var card2 = "home-module--card2--Ie87O";
export var card3 = "home-module--card3--vIVXX";
export var card4 = "home-module--card4--wjgcf";
export var card5 = "home-module--card5--ln3+I";
export var home = "home-module--home--5LoZ-";
export var intro = "home-module--intro--Y5P2-";
export var main = "home-module--main---G8Uv";
export var rotation = "home-module--rotation--IbJ8S";
export var service = "home-module--service--imrlQ";
export var services = "home-module--services--wi1We";
export var shape3 = "home-module--shape3--ICBHD";
export var shape5 = "home-module--shape5--XuKnX";
export var shape6 = "home-module--shape6--NCf3O";
export var shapes = "home-module--shapes--gfhDP";